import { render, staticRenderFns } from "./PositionGhanaFlag.vue?vue&type=template&id=72848104"
import script from "./PositionGhanaFlag.vue?vue&type=script&lang=js"
export * from "./PositionGhanaFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports